import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Gutter from '/component/layout/Gutter';
import ArrangedIcons from '/component/partial/ArrangedIcons';
import {Shared} from '/constant/TestIDs';

import {styles} from './TabNavigationHeader.style';

interface TabNavigationHeaderProps {
  rightIcons: string[];
  onIconPress: (iconName: string) => void;
  children: React.ReactNode;
}

export const TabNavigationHeader: React.FC<TabNavigationHeaderProps> = ({
  rightIcons = ['search'],
  onIconPress = () => noop,
  children = null,
}) => {
  const defaultAccessibilityLabelsRight =
    rightIcons.length === 2 &&
    rightIcons[0] === 'message' &&
    rightIcons[1] === 'search'
      ? ['Chat', 'Search']
      : undefined;
  const defaultRightIconTestIDs = rightIcons.map(iconName => {
    if (iconName === 'message') return Shared.chatButton;
    if (iconName === 'search') return Shared.searchButton;
    return null;
  });

  return (
    <View style={styles.base}>
      {children}
      <Gutter style={styles.icons}>
        <ArrangedIcons
          accessible={false}
          rightIcons={rightIcons}
          onIconPress={onIconPress}
          accessibilityLabelsRight={defaultAccessibilityLabelsRight}
          rightIconTestIDs={defaultRightIconTestIDs}
          style={{
            icon: styles.icon,
          }}
        />
      </Gutter>
    </View>
  );
};

export default TabNavigationHeader;
